import {
  GET_LOCATIONS_ERROR,
  GET_LOCATIONS_REQUEST,
  GET_LOCATIONS_SUCCESS,
  GET_RESOURCES_ERROR,
  GET_RESOURCES_REQUEST,
  GET_RESOURCES_SUCCESS,
  PUT_RESOURCES_ERROR,
  PUT_RESOURCES_REQUEST,
  PUT_RESOURCES_SUCCESS,
} from './constants';

export const getLocationsRequest = (branchId: number) => ({
  type: GET_LOCATIONS_REQUEST,
  payload: branchId,
});

export const getLocationsSuccess = (response: any) => ({
  type: GET_LOCATIONS_SUCCESS,
  payload: response,
});

export const getLocationsError = (error: any) => ({
  type: GET_LOCATIONS_ERROR,
  payload: error,
});

export const getResourcesRequest = (branchId: number) => ({
  type: GET_RESOURCES_REQUEST,
  payload: branchId,
});

export const getResourcesSuccess = (response: any) => ({
  type: GET_RESOURCES_SUCCESS,
  payload: response,
});

export const getResourcesError = (error: any) => ({
  type: GET_RESOURCES_ERROR,
  payload: error,
});

export const putResourcesRequest = (body: any) => ({
  type: PUT_RESOURCES_REQUEST,
  payload: body,
});

export const putResourcesSuccess = () => ({
  type: PUT_RESOURCES_SUCCESS,
});

export const putResourcesError = (error: any) => ({
  type: PUT_RESOURCES_ERROR,
  payload: error,
});

export type Actions =
  | ReturnType<typeof putResourcesRequest>
  | ReturnType<typeof putResourcesSuccess>
  | ReturnType<typeof putResourcesError>
  | ReturnType<typeof getResourcesRequest>
  | ReturnType<typeof getResourcesSuccess>
  | ReturnType<typeof getResourcesError>
  | ReturnType<typeof getLocationsRequest>
  | ReturnType<typeof getLocationsSuccess>
  | ReturnType<typeof getLocationsError>;
